import { Alert, Button } from "@mui/material";
import { IconEyeOff } from "@tabler/icons";
import React from "react";
import { useLocation } from "react-router-dom";
import { DATA_PRIVACY_PAGES, toggleDataPrivacy, useDataPrivacy } from "../../../../utils/dataPrivacy";

/**
 * Shown on every page while Data Privacy Mode is on. Only some pages are masked, so elsewhere it
 * says so: real data under a "privacy" banner would be worse than no banner.
 */
const DataPrivacyBanner: React.FC = () => {
  const on = useDataPrivacy();
  const { pathname } = useLocation();
  if (!on) return null;
  const applied = DATA_PRIVACY_PAGES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  return (
    <Alert
      icon={<IconEyeOff stroke={1.5} size="1.2rem" />}
      severity={applied ? "info" : "warning"}
      sx={{ mb: 2, alignItems: "center" }}
      action={
        <Button color="inherit" size="small" onClick={toggleDataPrivacy}>
          Turn off
        </Button>
      }
    >
      {applied ? "Data Privacy Mode" : "Data Privacy Mode is not applied on this page"}
    </Alert>
  );
};

export default DataPrivacyBanner;
